import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';
@Injectable()
export class CurrencyRateService {

  constructor(private http: HttpClient, private global: GlobalDataService) { }

   getCurrencyRate(){
         return this.http.get(this.global.httpUrl+"currencies/rates");
  }

   getCurrencyRateById(id: any){
         return this.http.get(this.global.httpUrl+"currencies/rates/"+id);
  }

  getCurrencyRateHistoryById(id:any,page:any){
         return this.http.get(this.global.httpUrl+"currencies/rates/histories?currency_rate_id="+id+"&page=" + page);
  }

  createCurrencyRate(data: any){
         return this.http.post(this.global.httpUrl+"currencies/rates",data);	
  }

   updateCurrencyRate(data: any,id: any){
         return this.http.put(this.global.httpUrl+"currencies/rates/"+id,data);  
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/currency_rates/currency-rate.service.ts